import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import ITEM_TEMPERATURE from '../../components/constants/itemTemperature';
import utils from '../../utils/utils';

const PackerCombinedOrderItemsTable = ({ combinedOrderItems, combinedOrderItemsMinusExcluded }) => {
  const [packedItemIds, setPackedItemIds] = useState([]);

  useEffect(() => {
    // reset "Packed" item state on order batch change
    setPackedItemIds([]);
  }, [combinedOrderItems]);

  const tempEnums = Object.keys(ITEM_TEMPERATURE).map((key) => ITEM_TEMPERATURE[key]);

  const { formatMessage } = useIntl();

  return (
    <table className="table table-striped">
      <thead>
        <tr>
          <th scope="col">
            <FormattedMessage id={'packer.delivery.day.marketplace.table.column.item'} />
          </th>
          <th scope="col">
            <FormattedMessage id={'packer.delivery.day.marketplace.table.column.quantity'} />
          </th>
          {combinedOrderItemsMinusExcluded?.length ? (
            <th scope="col">
              <FormattedMessage id={'packer.delivery.day.marketplace.table.column.quantity.minus.packed'} />
            </th>
          ) : (
            ''
          )}
        </tr>
      </thead>
      <tbody>
        {combinedOrderItems.map((combinedOrderItem, itemIndex) => {
          const temperature = combinedOrderItem.orderItem.item.temperature
            ? tempEnums.find((value) => value.name === combinedOrderItem.orderItem.item.temperature)
            : null;

          const excludedCoi = combinedOrderItemsMinusExcluded?.find(
            (coi) => coi.orderItem.item.id === combinedOrderItem.orderItem.item.id
          );

          const quantity = excludedCoi?.quantity || 0;

          const packedIndex = packedItemIds.findIndex((itemId) => itemId === combinedOrderItem.orderItem.item.id);

          return (
            <tr key={itemIndex}>
              <td
                onClick={() => {
                  const newPackedItemIds = packedItemIds.slice();
                  if (packedIndex >= 0) {
                    newPackedItemIds.splice(packedIndex, 1);
                  } else {
                    newPackedItemIds.push(combinedOrderItem.orderItem.item.id);
                  }
                  setPackedItemIds(newPackedItemIds);
                }}
              >
                <div className={`text-large ${packedIndex >= 0 ? 'text-strikethrough text-muted' : ''}`}>
                  {utils.getItemName(combinedOrderItem.orderItem.item, formatMessage)}{' '}
                  {temperature ? temperature.icon : ''}
                </div>
              </td>
              <td>{combinedOrderItem.quantity}</td>
              {combinedOrderItemsMinusExcluded?.length ? (
                <td className={`${quantity < combinedOrderItem.quantity ? 'text-main-dark' : ''}`}>{quantity}</td>
              ) : (
                ''
              )}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

PackerCombinedOrderItemsTable.propTypes = {
  combinedOrderItems: PropTypes.array.isRequired,
};

PackerCombinedOrderItemsTable.defaultProps = {};

export default PackerCombinedOrderItemsTable;
